import MonthYearSelector from "@components/inputs/date/MonthYearSelector";
import { StyledField } from "@components/inputs/field/Field.styles";
import { StyledLabel } from "@components/inputs/field/Label.styles";
import { getInputPadding, INPUT_MIN_HEIGHT } from "@components/inputs/input/Input.styles";
import Tabs from "@components/tabs";
import { TabWrapper } from "@components/tabs/Tabs.styles";
import styled from "styled-components";

import { T_PLAIN_big } from "../../../global.style";

export const TabsStyled = styled(Tabs)`
    ${TabWrapper} {
        margin-top: 40px;
        margin-bottom: 0;
    }
`;

export const DeductionsWrapper = styled.div`
    display: grid;
    grid-template-columns: max-content auto auto;
    column-gap: 20px;
    row-gap: 12px;
    
    ${StyledLabel} {
        min-height: ${INPUT_MIN_HEIGHT}px;
        margin: 0;
        align-items: center;
    }
    
    ${StyledField} {
        margin-right: 0 !important;
    }
`;

export const DeductionItem = styled.span`
    ${T_PLAIN_big};
    line-height: 1.2;
`;

export const LikeReadOnlyFieldButLowerAndAlignWithNonReadOnlyField = styled(DeductionItem)`
    text-align: right;
    padding: ${getInputPadding()};
    padding-top: 0;
    padding-bottom: 0;
`;

export const StyledMonthYearSelector = styled(MonthYearSelector)`
    margin-bottom: 36px;
`;